import { getName } from "i18n-iso-countries";

// Interfaces
import { Bisnode } from "../interfaces/API";
import { PaymentChoice, PaymentInformation } from "../interfaces/Payment";
import { PersonContactInfo } from "../interfaces/Person";
import { CgiProvider } from "../interfaces/CGI";

export const bisnodeResultToContactInformation = (bisnodeResult: Bisnode | null): PersonContactInfo => {
  let contactInfo: PersonContactInfo = {
    firstName: '',
    familyName: '',
    street: '',
    postalCode: '',
    city: '',
    email: '',
    phoneNumber: '',
    country: '',
    personalIdentityNumber: '',
  };

  if (bisnodeResult === null) {
    return contactInfo;
  }

  const firstName = bisnodeResult.PreferredFirstName;
  const familyName = bisnodeResult.FamilyName;

  if (firstName) contactInfo.firstName = firstName;
  if (familyName) contactInfo.familyName = familyName;

  // Add address information if there is any to the initial value
  if (
    bisnodeResult &&
    Array.isArray(bisnodeResult.AddressList) &&
    bisnodeResult.AddressList.length > 0
  ) {
    const streetName = bisnodeResult.AddressList[0].StreetName;
    const streetNumber = bisnodeResult?.AddressList[0].StreetNumber;
    const postalCode = bisnodeResult?.AddressList[0].PostalCode;
    const city = bisnodeResult?.AddressList[0].City;
    // Bisnode returns the country in ISO 3166-1 alpha-2 standard, e.g SE = Sweden
    const countryCode = bisnodeResult?.AddressList[0].Country;
    if (streetName) contactInfo.street = `${streetName} ${streetNumber}`;
    if (postalCode) contactInfo.postalCode = postalCode;
    if (city) contactInfo.city = city;
    if (countryCode) {
      // Get the full name of country code in swedish language
      contactInfo.country = getName(countryCode, 'sv');
    }
  }

  return contactInfo;
}

export const getBankNumber = (paymentChoice: PaymentChoice | null): string => {
  switch (paymentChoice?.choice) {
    case 'autogiro':
      const clearingNumber = paymentChoice.bankInfo?.clearingNumber || '';
      const bankNumber = paymentChoice.bankInfo?.bankNumber || '';
      return clearingNumber + bankNumber;
    default:
      return '';
  }
};

export const getAutoGiroInfo = (
  paymentChoice: PaymentChoice | null
): PaymentInformation => {
  const paymentInformation: PaymentInformation = {
    bank: '',
    clearingNumber: '',
    bankNumber: '',
  };
  if (paymentChoice?.choice === 'autogiro') {
    paymentInformation.bankNumber = paymentChoice.bankInfo?.bankNumber;
    paymentInformation.clearingNumber =
      paymentInformation.bank = paymentChoice.bankInfo?.bank;
    paymentChoice.bankInfo?.clearingNumber;
  }
  return paymentInformation;
};

export const getAssociation = (paymentChoice: PaymentChoice | null): string => {
  return paymentChoice?.choice === 'association' ? paymentChoice?.viaAssociation || '' : '';
}

export const getProviderNameFromProvider = (provider: CgiProvider): string => {
  switch (provider) {
    case CgiProvider.BankId:
      return 'BankID';
    case CgiProvider.Freja:
    default:
      return 'Freja eID';
  }
}